module.exports = __webpack_public_path__ + "static/img/summitterraLogo.6f45ffe3.png";